import './home.scss';
import '../../assets/styles/top-menu.scss';

import products from '../../assets/js/products';

const $contactForm = $('form#contact-form'), $quoteForm = $('form#quotation-form'), urlQuote= 'https://script.google.com/macros/s/AKfycbyYvMRUtHnu6lmjcAWUJ0QudvRqM_sjADNaIAl7yO1MfTbpSlI/exec', url = 'https://script.google.com/macros/s/AKfycbxwfYLPZ2bWbUCeXPqga_vRnDDrvrENF1qUOHumg46vF_J6u_0/exec';
$contactForm.validate({
  errorPlacement: function(error, element) {},
});

$quoteForm.validate({
  errorPlacement: function(error, element) {},
});

function getFormData($form) {
  const unIndexed_array = $form.serializeArray();
  const indexed_array = {};

  $.map(unIndexed_array, function(n, i){
    indexed_array[n['name']] = n['value'];
  });

  return indexed_array;
}

$('#submit-contact-form').click(function(e) {
  e.preventDefault();
  if ($contactForm.valid()) {
    $("#submit-contact-form").text('Cargando...');
    $.ajax({
      url: url,
      method: "GET",
      dataType: "json",
      data: {...getFormData($contactForm), Fecha: new Date()},
      success: function (res) {
        $('#contact-thanks').appendTo('body').modal({
          fadeDuration: 250
        });
        $contactForm[0].reset();
        $("#submit-contact-form").text('Enviar');
      }
    })
  } else {
    var $inputs = $('#contact-form :input');
    $inputs.each(function() {
      var input = $(this);
      if (!input.valid()) {
        input.addClass('error');
      } else {
        input.removeClass('error');
      }
    });
  }
});

$('#submit-quotation-form').click(function(e) {
  e.preventDefault();
  if ($quoteForm.valid()) {
    $("#submit-quotation-form").text('Cargando...');
    $.ajax({
      url: urlQuote,
      method: "GET",
      dataType: "json",
      data: {...getFormData($quoteForm), Fecha: new Date()},
      success: function (res) {
        $('#contact-thanks-2').appendTo('body').modal({
          fadeDuration: 250
        });
        $quoteForm[0].reset();
        $("#submit-quotation-form").text('Enviar');
      }
    })
  } else {
    var $inputs = $('#quotation-form :input');
    $inputs.each(function() {
      var input = $(this);
      if (!input.valid()) {
        input.addClass('error');
      } else {
        input.removeClass('error');
      }
    });
  }
});

$(document).ready(function() {
  addProducts();
  addOptions();
});

function getProductDetails(product) {
  if (product.models.length) {
    if (product.models[0].sections && product.models[0].sections[0]) {
      return product.models[0].sections[0].subtitle + ' ' + product.models[0].sections[0].text.split(" ").slice(0, 10).join(' ') + '...';
    }
  }
  return '';
}

const addOptions = function () {
  const productsSelect = $('#product-select');
  productsSelect.append(
      `
        <option value="">
          Selecciona el producto
        </option>
      `
  )
  products.forEach(product => {

    productsSelect.append(
        `
          <option value="`+ product.name + `">
            `+ product.name + `
          </option>
        `
    )
  })
}

const addProducts = function () {
  const productsRow = $('#products-row');
  products.forEach(product => {
    productsRow.append(
        `
        <div id="product-` + product.name + `" class="product">
            <div class="img-box">
              <img alt="` + product.alt + `" src="` + (product.photos.length ? product.photos[0] : '../assets/productos/Artboard.jpg') + `">
            </div>
            <div class="ubuntu product-title">
              ` + product.name + `
            </div>
            <div class="helvetica-light product-details">
              ` +  getProductDetails(product) + `
            </div>
            `
              + (!product.hide ? `<div class="view-row">
              <a href="./product.html?product=` + product.name + `" class="view-box">
                <span class="ubuntu">Ver más</span>
                <div class="img-box">
                  <img alt="arrow" src="../assets/images/flecha-correcta.png">
                </div>
              </a>
            </div>` : '') +
            `
          </div>
        `
    )
  })
}
